// extracted by mini-css-extract-plugin
export default {"background-$(backgroundColorBg)":"a320F","background-$(backgroundColor)":"b320F","external":"c320F","header":"d320F","row":"e320F","button":"f320F","plate":"g320F"};